// src/components/HomePage.jsx
import React, { useEffect, useState } from "react";
import { getDocs, collection } from "firebase/firestore";
import { db } from "../firebase";
import CarouselComponent from "./Carousel";
import Departments from "./Departments";
import CTAWithLocation from "./hooks/CTAWithLocation";
import { useRouteMeta } from "./hooks/useRouteMeta";

const HomePage = () => {
  // ⭐ Load SEO meta tags from: MetaTags / HomePage
  useRouteMeta("HomePage");

  const [carouselImages, setCarouselImages] = useState([]);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const snapshot = await getDocs(collection(db, "carouselImages"));
        const images = snapshot.docs
          .map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }))
          .filter((img) => img.imageUrl)
          .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

        setCarouselImages(images);
      } catch (error) {
        console.error("Error loading carousel images:", error);
      }
    };

    fetchImages();
  }, []);

  return (
    <>
      <CarouselComponent images={carouselImages} />
      <Departments />

      <CTAWithLocation
        headingText="Ready to transform your workspace? Contact us today!"
        buttonText="Learn More"
        currentPath={location.pathname}
      />
    </>
  );
};

export default HomePage;
